import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;
const cdnImage = (u) => {
  if (!u) return '/images/placeholder.svg';
  if (u.startsWith('/')) return `${API}${u}`;
  return u;
};
const formatPrice = (p) =>
  new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(p || 0);

/**
 * Intelligentes, modulbasiertes Cross-Selling für Premium-Marken.
 * Erwartet `groups` = [{ module, products:[...] }] vom Backend
 * (Novitec-Teile fürs selbe Fahrzeug zuerst, danach passende Fremdmarken).
 */
export default function NovitecCrossSell({ groups = [], vehicle = '' }) {
  const validGroups = useMemo(
    () => (groups || []).filter((g) => (g.products || []).length > 0),
    [groups]
  );
  const [active, setActive] = useState(0);

  if (!validGroups.length) return null;
  const current = validGroups[Math.min(active, validGroups.length - 1)];

  return (
    <section className="nv-cross" data-testid="novitec-cross-selling">
      <div className="nv-sec-head">
        <span className="nv-eyebrow">Perfekte Ergänzung</span>
        <h3 className="nv-sec-title">
          PASSEND FÜR {vehicle ? <strong>{vehicle.toUpperCase()}</strong> : <strong>DEIN FAHRZEUG</strong>}
        </h3>
      </div>

      {validGroups.length > 1 && (
        <div className="nv-cross__tabs" role="tablist">
          {validGroups.map((g, i) => (
            <button key={g.module} role="tab" aria-selected={i === active}
                    className={`nv-cross__tab ${i === active ? 'is-active' : ''}`}
                    onClick={() => setActive(i)}
                    data-testid={`novitec-cross-tab-${i}`}>
              {g.module}
              <span className="nv-cross__tab-count">{g.products.length}</span>
            </button>
          ))}
        </div>
      )}

      <div className="nv-cross__grid" data-testid="novitec-cross-grid">
        {current.products.slice(0, 8).map((p) => (
          <Link key={p.alias} to={`/p/${p.slug}`} className="nv-cross__card"
                data-testid={`novitec-cross-card-${p.alias}`}>
            <div className="nv-cross__img">
              <img src={cdnImage(p.image_url)} alt={p.name} loading="lazy"
                   onError={(e) => { e.target.src = '/images/placeholder.svg'; }} />
            </div>
            <div className="nv-cross__info">
              {p.manufacturer && <span className="nv-cross__brand">{p.manufacturer}</span>}
              <h4 className="nv-cross__name">{p.name}</h4>
              {p.manufacturer_sku && <span className="nv-cross__sku">Art.-Nr. {p.manufacturer_sku}</span>}
              <span className="nv-cross__price">{p.price > 0 ? formatPrice(p.price) : 'Auf Anfrage'}</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
